import { useGetPageId } from 'src/utils/getPageId';
import { usePickBlock } from 'src/utils/pick-block';

export const usePageFixedWidth = () => {
  const pageId = useGetPageId();
  const pageBlock = usePickBlock(pageId, ['data'], ['pageFixedWidth', 'directoryMenu']);
  return (pageBlock?.data ?? {})?.pageFixedWidth ?? true;
};
